<template>
	<div class="row">
		<div class="col-md-12">
			<section class="panel">
				<header class="panel-heading">
					<h2 class="panel-title">設定開放時間</h2>
				</header>
				<div class="panel-body container-fluid">
					<div class="row form-group" v-for="(item, index) in roomTimeSettingList" :key="index">
						<div class="col-md-2 col-sm-2 col-xs-12 form-group">
							<label>{{settingTitle(item.commCode)}}</label>
						</div>
						<div v-if="item.commCode == 'APPLY_YM'">
							<div class="col-md-5 col-sm-5 col-xs-12 form-group" >
								<label>開放學年&nbsp;&nbsp;</label>
								<select v-model="applyY">
									<option value="">--請選擇--</option>
									<option v-for="(key,index) in yearList" :key="index" :value="key">{{key}}學年</option>
								</select>
							</div>
							<div class="col-md-5 col-sm-5 col-xs-12 form-group" >
								<label>開放學期&nbsp;&nbsp;</label>
								<select v-model="applyM">
									<option value="">--請選擇--</option>
									<option value="1">第一學期</option>
									<option value="2">第二學期</option>
								</select>
							</div>
						</div>
						<div v-else-if="item.commCode == 'PAY'">
							<div class="col-md-5 col-sm-5 col-xs-12 form-group">
								<label>繳費截止日&nbsp;&nbsp;</label>
								<datepicker :format="customFormatter" :language="zh" input-class="form-control" v-model="item.commValue" name="beginDate" :style="{width:'auto', display:'inline-block'}">
								</datepicker>
								<span class="text-danger" v-show="errors.has('beginDate')">{{ errors.first('beginDate') }}</span>
							</div>
						</div>
						<div v-else>
							<div class="col-md-5 col-sm-5 col-xs-12 form-group">
								<label>開放日&emsp;&emsp;&nbsp;&nbsp;</label>
								<datepicker :format="customFormatter" :language="zh" input-class="form-control" v-model="item.commValue" name="beginDate" :style="{width:'auto', display:'inline-block'}">
								</datepicker>
								<span class="text-danger" v-show="errors.has('beginDate')">{{ errors.first('beginDate') }}</span>
							</div>
							<div class="col-md-5 col-sm-5 col-xs-12 form-group" >
								<label>結束日&emsp;&emsp;&nbsp;&nbsp;</label>
								<datepicker :format="customFormatter" :language="zh" input-class="form-control" v-model="item.commValue2" name="endDate" :style="{width:'auto', display:'inline-block'}">
								</datepicker>
								<span class="text-danger" v-show="errors.has('endDate')">{{ errors.first('endDate') }}</span>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12">
							<div class="col-md-2 "></div>
							<div class="col-md-2 col-xs-3"></div>
							<div class="col-md-2 col-xs-3">
								<button @click="handleCancel" class="btn btn-default btn-block">取消</button>
							</div>
							<div class="col-md-2 col-xs-3">
								<button @click="handleSave" class="btn btn-primary btn-block">儲存</button>
							</div>
							<div class="col-md-2 col-xs-3"></div>
							<div class="col-md-2 "></div>
						</div>
					</div>
				</div>
				
			</section>

		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			settintList:[],
			roomTimeSettingList: [],
			applyY:"",
			applyM:"",
		}
	},
	created() {
		const api = "/api/Common/roomTimeSetting/"
		this.$axios.post(api).then(resp => {
			this.roomTimeSettingList = resp.data.data.roomTimeSettingList
			let applyYm = this.roomTimeSettingList.filter(item =>{
				return item.commCode == "APPLY_YM";
			});
			if(applyYm.length > 0){
				this.applyY = applyYm[0].commValue;
				this.applyM = applyYm[0].commValue2;
			}
		});
	},
	updated() {
	},
	methods: {
		handleCancel() {
			this.$router.go(-1)
		},
		handleSave() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.roomTimeSettingList.forEach(item =>{
						// console.log(item);
						if(item.commCode == "APPLY_YM"){
							item.commValue = this.applyY;
							item.commValue2 = this.applyM;
						}else{
							item.commValue = this.customFormatter(item.commValue);
							if(item.commCode != "PAY"){
								item.commValue2 = this.customFormatter(item.commValue2);
							}
						}
					});
					const api = "/api/Common/saveRoomTimeSetting";
					this.$axios.post(api, this.roomTimeSettingList ).then(resp => {
						if (resp.data.status === "success") {
							if (this.applyType === 'N' && this.editStatus === 'N') {
								this.$router.push({ name: 'index' })
							} else {
								this.$router.push({ name: 'stay.list' })
							}
						} else {
							bootbox.alert(resp.data.msg)
						}
					});
				} else {
					bootbox.alert("請確認必填欄位是否有填寫")
				}
			});

		},
		settingTitle(commCode){
			let str = "";
			if(commCode == "N"){
				str = "一般申請住宿: ";
			}else if(commCode == "V"){
				str = "寒暑假申請住宿: ";
			}else if(commCode == "L"){
				str = "離宿申請住宿: ";
			}else if(commCode == "PAY"){
				str = "繳費期限: ";
			}else if(commCode == "APPLY_YM"){
				str = "住宿申請學年期: ";
			}
			return str;
		}
	},
	computed:{
		yearList(){
			let years = [];
			for(let i=(new Date().getUTCFullYear() -1911); i >= 109; i--){
				years.push(i.toString());
			}
			return years;
		}
	}
}
</script>

<style scoped>
</style>
